import React from 'react';
import classnames from 'classnames';
import { Section } from '@fiverr-private/fit';
import { ROLLOUTS } from '@fiverr-private/listing_experiments';
import { BriefFloatingFormTrigger, ListingFlow } from '@fiverr-private/dm_brief_creation';
import { useInBriefFloatingFormExperiment } from '../../../../hooks/useInBriefFloatingFormExperiment';
import { MAX_ITEMS_TO_SHOW_NO_RESULTS } from '../../../../constants';
import { useAppContext } from '../../../context/listingsContext';
import AssetsVerifier from '../../AssetsVerifier';
import { ProOrientedSearchModal } from '../../ProOrientedSearchModal';
import Header from '../Header';
import { useBusinessListingsContext } from '../Context';
import { getBqEventSource } from '../../biUtils';
import { useBffForceOpen } from './useBffForceOpen';
import { getCookieValue, setCookieWithExpiration } from './utils';

import styles from './index.module.scss';

const CLICKED_EDIT_BRIEF_COOKIE_KEY = 'bff_pro_listings_clicked_edit_brief';

const BusinessLayout = ({ isObservedItemSeen, observedItemIndex, children }) => {
    const {
        flow,
        categoryIds,
        query,
        listingQuery,
        significantLeafCategories,
        dominateSubCategoryId,
        currency,
        appData,
        appFilters,
    } = useAppContext();
    const inBffExperiment = useInBriefFloatingFormExperiment();

    const { rollouts, resultsCount, isExpertListings } = useBusinessListingsContext();
    const inMustangsVerifyAssetsRollout = rollouts[ROLLOUTS.MUSTANGS_VERIFY_ASSETS];

    const hasFewResults = isExpertListings && resultsCount < MAX_ITEMS_TO_SHOW_NO_RESULTS;
    const shouldShowBff =
        inBffExperiment && !hasFewResults && resultsCount > 0 && Object.values(ListingFlow).includes(flow);
    const firstPage = !(appData?.pagination?.page > 1);
    const filtered = appFilters?.selectedFilters?.length > 0;
    const clickedEditBrief = getCookieValue(CLICKED_EDIT_BRIEF_COOKIE_KEY);
    const shouldAllowForcedOpen = shouldShowBff && firstPage && !filtered && !clickedEditBrief;

    const leafCategory = categoryIds.nestedSubCategoryId || categoryIds.subCategoryId;
    const dlc = significantLeafCategories?.[0] || dominateSubCategoryId;

    const { forceOpenSettings, resetForceOpenSettings } = useBffForceOpen(shouldAllowForcedOpen, isObservedItemSeen);

    const onEditBriefClick = () => {
        setCookieWithExpiration(CLICKED_EDIT_BRIEF_COOKIE_KEY, true, 14, false);
    };

    return (
        <Section className={classnames(styles.main, 'listings-perseus')}>
            <Header />
            <div className="flex flex-items-start">{children}</div>
            {inMustangsVerifyAssetsRollout && <AssetsVerifier />}
            <ProOrientedSearchModal />
            {shouldShowBff && (
                <BriefFloatingFormTrigger
                    listingFlow={flow}
                    searchQuery={query || listingQuery}
                    pageName={getBqEventSource(isExpertListings)}
                    currency={currency}
                    forceOpen={forceOpenSettings.isForceOpen}
                    afterForceOpen={forceOpenSettings.afterForceOpen}
                    triggerScenario={forceOpenSettings.triggerScenario}
                    onClose={resetForceOpenSettings}
                    afterForceOpenRefused={resetForceOpenSettings}
                    onEditBriefClick={onEditBriefClick}
                    {...(isObservedItemSeen && { openingPosition: observedItemIndex + 1 })}
                    {...(leafCategory && { leafCategory: Number(leafCategory) })}
                    {...(dlc && { dlc: Number(dlc) })}
                />
            )}
        </Section>
    );
};

export default BusinessLayout;
